import api from '../utils/api';

export async function listAgentsAdmin({ page = 1, perPage = 20, search = null } = {}) {
  const params = { page, per_page: perPage };
  if (search) {
    params.search = search;
  }
  const { data } = await api.get('/admin/agents', { params });
  return data;
}

export async function getAgentAdmin(agentId) {
  const { data } = await api.get(`/admin/agents/${agentId}`);
  return data;
}
